import clsx from "clsx";
import ArrowUpIcon from "ui/common/icons/ArrowUpIcon";
import CameraIcon from "ui/common/icons/CameraIcon";
import useTranslate from "ui/locale/hooks/useTranslate";
import ButtonWithIcon from "../../ButtonWithIcon/ButtonWithIcon";
import { UploadButtonDisplayConfig, UploadButtonDisplayProps } from "./UploadButtonDisplay.types";

export const UPLOAD_BUTTON_DISPLAY_CONFIG: UploadButtonDisplayConfig = {
    upload: {
        Icon: ArrowUpIcon,
        label: "uploadImage",
    },
    change: {
        Icon: CameraIcon,
        label: "change",
    },
};

const UploadButtonDisplay = ({ display, className, changeButtonProps = {}, uploadButtonProps = {}, ...rest }: UploadButtonDisplayProps) => {
    const translate = useTranslate();
    const { Icon, label } = UPLOAD_BUTTON_DISPLAY_CONFIG[display];
    const { label: customLabel, Icon: CustomIcon } = display === "upload" ? uploadButtonProps : changeButtonProps;

    return (
        <ButtonWithIcon
            className={clsx("upload-button-display", display, className)}
            {...rest}
            label={customLabel || translate(label)}
            Icon={CustomIcon || Icon}
        />
    );
};

export default UploadButtonDisplay;
